import { render, staticRenderFns } from "./PDFCotizaciones.vue?vue&type=template&id=9350acfc&"
import script from "./PDFCotizaciones.vue?vue&type=script&lang=js&"
export * from "./PDFCotizaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports